"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeHandler = void 0;
var constants_1 = require("../constants");
var typeHandler = function (type) {
    switch (type) {
        case "spring":
            return constants_1.SPRING;
        case "summer":
            return constants_1.SUMMER;
        case "autumn":
            return constants_1.AUTUMN;
        case "winter":
            return constants_1.WINTER;
        default:
            return;
    }
};
exports.typeHandler = typeHandler;
